import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 100,
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 15,
      },
    },
  },
  HEADLINE: {
    fontSize: "32pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    mobile: {
      desktop: {
        fontSize: "32pt",
      },
      smartphone: {
        fontSize: "22pt",
      },
    },
  },
  TEXT: {
    padding: 20,
    fontSize: "13pt",
    fontFamily: theme.fontFamily,
    lineHeight: "18pt",
  },
};
